















import { Vue, Component, Prop, Model } from 'vue-property-decorator';

import ImageInput from './ImageInput.vue';

import { Photo, Maybe } from '@/types/common';

// entity without id is local and doesn't exist on the server
const NO_ID = 0;

@Component({
    components: {
        ImageInput,
    },
})
export default class ImageInputEntity extends Vue {
    @Model('update:photo', { required: true }) photo!: Maybe<Photo>;
    @Prop({ required: true }) data!: any;
    @Prop({ default: '' }) error!: string;
    @Prop({ default: false }) readonly!: boolean;

    get dataWrapper() {
        return {
            ...this.data,
            error: this.error,
            value: this.photo?.file,
            preview: this.photo?.src
        }
    }
        
    loadImage(file: File) {
        const src = URL.createObjectURL(file);
        
        const photo = {
            id: NO_ID,
            file,
            src,
        }

        this.$emit('update:photo', photo);
    }

    clearLocalImage() {
        if (this.photo?.id === NO_ID) {
            URL.revokeObjectURL(this.photo.src);
        }
    }

    removeImage() {
        this.clearLocalImage();        

        this.$emit('update:photo', null);
    }

    beforeDestroy() {
        this.clearLocalImage;
    }
}
